import React, {useEffect, useState} from 'react';
import {Button, Form, Input} from 'antd';
import {
    authAPI,
    CreateTokenRequest,
} from "../services/AuthService";
import {Navigate} from "react-router-dom";

export const MainScreen: React.FC = () => {
    return (
        <div style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            Страничка приветствия!
        </div>
    );
};